import { render } from "./addContact.vue?vue&type=template&id=47437322&scoped=true"
import script from "./addContact.vue?vue&type=script&lang=js"
export * from "./addContact.vue?vue&type=script&lang=js"

import "./addContact.vue?vue&type=style&index=0&id=47437322&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47437322"],['__file',"src/views/channel/components/addContact.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "47437322"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('47437322', __exports__)) {
    console.log('reload')
    api.reload('47437322', __exports__)
  }
  
  module.hot.accept("./addContact.vue?vue&type=template&id=47437322&scoped=true", () => {
    console.log('re-render')
    api.rerender('47437322', render)
  })

}


export default __exports__